var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"id":_vm.id}},[_c('span',{staticClass:"px-5 py-2 rounded-lg",style:({ color: _vm.value.color, backgroundColor: _vm.value.bg })},[_vm._v(" "+_vm._s(_vm.value.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }